var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    y: 0.875,
    width: 55.9999,
    height: 55.9999,
    rx: 27.9999,
    stroke: "url(#paint0_linear_10240_248057)",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10240_248057",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 30,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2585 16.8723C41.8302 16.8723 43.1051 18.1464 43.1052 19.718V38.0315C43.1052 39.6032 41.8303 40.8771 40.2585 40.8772H17.491C15.9194 40.877 14.6453 39.6031 14.6453 38.0315V19.718C14.6454 18.1464 15.9194 16.8724 17.491 16.8723H40.2585ZM17.491 18.6047C16.8762 18.6049 16.3778 19.1032 16.3777 19.718V38.0315C16.3778 38.6463 16.8761 39.1446 17.491 39.1447H40.2585C40.8735 39.1447 41.3727 38.6464 41.3728 38.0315V19.718C41.3726 19.1031 40.8735 18.6047 40.2585 18.6047H17.491ZM34.4431 22.4406C34.9213 22.4408 35.3093 22.8286 35.3093 23.3069C35.3093 25.0132 34.6311 26.6501 33.4246 27.8567C32.218 29.0631 30.581 29.7414 28.8748 29.7414C27.1685 29.7413 25.5315 29.0632 24.325 27.8567C23.1184 26.6501 22.4402 25.0132 22.4402 23.3069C22.4402 22.8286 22.8282 22.4409 23.3064 22.4406C23.7848 22.4406 24.1726 22.8285 24.1726 23.3069C24.1727 24.5538 24.6679 25.7503 25.5496 26.632C26.4312 27.5137 27.6279 28.0089 28.8748 28.009C30.1214 28.009 31.3173 27.5133 32.199 26.632C33.0807 25.7503 33.5768 24.5538 33.5769 23.3069C33.5769 22.8286 33.965 22.4409 34.4431 22.4406Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10240_248057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6932 11.0566H11.0569V46.6929H46.6932V11.0566Z",
    fill: "url(#paint1_linear_10240_248057)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10240_248057",
    x1: 28.875,
    y1: 0.875,
    x2: 28.875,
    y2: 56.8749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#786CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10240_248057",
    x1: 28.875,
    y1: 11.0566,
    x2: 28.875,
    y2: 46.6929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#786CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AFF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.b1456b19d7710895d3ac803c7de769e6.svg";
export { ForwardRef as ReactComponent };